import { render, staticRenderFns } from "./editPage.vue?vue&type=template&id=ab0c1a2e&lang=pug&"
import script from "./editPage.vue?vue&type=script&lang=js&"
export * from "./editPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports